(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-ratgeber"]) return;
  try {
    
  const initializeCollectionGuides = (root = document) => {
    root.querySelectorAll('[data-collection-guide]').forEach((section) => {
      if (section.dataset.collectionGuideReady === 'true') return;

      const content = section.querySelector('[data-collection-guide-content]');
      const actions = section.querySelector('[data-collection-guide-actions]');
      const toggle = section.querySelector('[data-collection-guide-toggle]');
      const label = section.querySelector('[data-collection-guide-label]');

      if (!content || !actions || !toggle || !label) return;

      section.dataset.collectionGuideReady = 'true';

      requestAnimationFrame(() => {
        if (content.scrollHeight <= 920) return;

        section.classList.add('is-collapsible');
        actions.hidden = false;

        toggle.addEventListener('click', () => {
          const isExpanded = section.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', String(isExpanded));
          label.textContent = isExpanded ? label.dataset.viewLess : label.dataset.viewMore;
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCollectionGuides());
  } else {
    initializeCollectionGuides();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCollectionGuides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const companyFooterMobile = window.matchMedia('screen and (max-width: 640px)');

  function syncCompanyFooterVisibility() {
    if (companyFooterMobile.matches) return;

    document.querySelectorAll('.footer__block-item--company-address').forEach(function(block) {
      const toggle = block.querySelector('[data-action="toggle-collapsible"]');
      const panel = block.querySelector('.footer__collapsible');
      if (!toggle || !panel) return;

      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.style.height = '';
    });
  }

  companyFooterMobile.addEventListener('change', syncCompanyFooterVisibility);
  document.addEventListener('shopify:section:load', syncCompanyFooterVisibility);
  syncCompanyFooterVisibility();

  } catch(e) { console.error(e); }
})();
})();
